export const pillFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "20px",
    paddingLeft: "6px",
    paddingRight: "6px",
  },
  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
  },
  "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
    marginLeft: "4px",
  },
};
